import React from "react";
import { List } from "@refinedev/mui";

import { DataGrid } from "@shared/components/DataGrid";
import { CsvExportButton, FilterDropdown } from "@shared/components";
import { ReferralListFilters } from "@modules/referrals/components/ReferralListFilters";
import { PayReferralModal } from "@modules/referrals/components/PayReferralModal";

import { useReferralList } from "./controller";
import { useReferralListColumns } from "./columns";

export const ReferralList = React.memo(() => {
  const {
    rows,
    loading,
    selectedRows,
    dataToExport,
    companies,
    payModalRef,
    setSelectedRows,
    refetch,
    translate,
    tableProps,
  } = useReferralList();

  const columns = useReferralListColumns(translate, payModalRef, companies);

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
              agreement: "",
            }}
          >
            <ReferralListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="referrals.csv"
            isDisabled={loading || !rows}
          />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as string[])
        }
      />

      <PayReferralModal modalRef={payModalRef} onComplete={refetch} />
    </List>
  );
});
